const CryptoJS = require('crypto-js');

const secretKey = process.env.REACT_APP_SECRET_KEY;

const encrypt = (pass) => {
  const ciphertext = CryptoJS.AES.encrypt(pass, secretKey).toString();
  return ciphertext;
};

export default encrypt;
